module.exports = __webpack_public_path__ + "static/media/belly.788f042c.png";